module.exports = __webpack_public_path__ + "static/Dawex-181c211edb692b777f35dfc320f5ee75.jpg";